import axios from 'axios'

export const getAllPromotions = (params) => {
  let remoteUrl = 'promotions'

  return axios.get(remoteUrl, {params: params})
}

export const getPromotions = (id, params) => {
  let remoteUrl = 'promotions/' + id

  return axios.get(remoteUrl, {params: params})
}

export const addPromotions = (data) => {
  let remoteUrl = 'promotions'
  return axios.post(remoteUrl, data)
}

export const editPromotions = (id, data) => {
  let remoteUrl = 'promotions/' + id
  return axios.put(remoteUrl, data)
}

export const deletePromotions = (id) => {
  let remoteUrl = 'promotions/' + id
  return axios.delete(remoteUrl)
}

export const restorePromotions = (id) => {
  return axios.post('promotions/' + id + '/restore', {})
}

export const getPromotionHelpers = () => {
  return axios.get('helpers/promotions')
}



// WEBPACK FOOTER //
// ./src/api/promotion.js